import { render, staticRenderFns } from "./UndoToast.vue?vue&type=template&id=050be262&scoped=true"
import script from "./UndoToast.vue?vue&type=script&lang=js"
export * from "./UndoToast.vue?vue&type=script&lang=js"
import style0 from "./UndoToast.vue?vue&type=style&index=0&id=050be262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050be262",
  null
  
)

export default component.exports